import { render, staticRenderFns } from "./CFieldNew.vue?vue&type=template&id=244dcd30&"
import script from "./CFieldNew.vue?vue&type=script&lang=js&"
export * from "./CFieldNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports